export default "__VITE_ASSET__DhkTmYA4__"